import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const deskattributes = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getDeskAttributes(){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-attributes`)
  },
  getActiveDeskAttributes(){
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/desk-attributes/active`)
  },
  addDeskAttribute (attribute) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-attributes`, attribute)
  },
  updateDeskAttribute (attribute) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-attributes/${attribute.id}`, attribute)
  },
  activateDeskAttribute (attributeId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-attributes/${attributeId}/activate`)
  },
  deactivateDeskAttribute (attributeId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-attributes/${attributeId}/deactivate`)
  }
}

export default deskattributes
